import './WorkflowSidebar.css'

interface WorkflowStep {
  number: number
  title: string
  subtitle: string
  active: boolean
}

interface WorkflowSidebarProps {
  onStepSelect: (step: number) => void
  workflowSteps: WorkflowStep[]
}

const WorkflowSidebar = ({ onStepSelect, workflowSteps }: WorkflowSidebarProps) => {
  return (
    <div className="workflow-sidebar">
      <div className="workflow-container">
       

        <div className="workflow-steps">
          {workflowSteps.map((step) => (
            <div
              key={step.number}
              className={`workflow-step-item ${step.active ? 'active' : 'inactive'}`}
              onClick={() => {
                onStepSelect(step.number)
                console.log(`Clicked on step ${step.number}: ${step.title}`)
              }}
            >
              
              {/* Step Content */}
              <div className="step-content">
                <h3 className={`step-title ${step.active ? 'active' : 'inactive'}`}>
                  {step.title}
                </h3>
                <p className={`step-subtitle ${step.active ? 'active' : 'inactive'}`}>
                  {step.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WorkflowSidebar
